import type { App } from 'vue'
import { VueQueryPlugin } from '@tanstack/vue-query'

export function installVueQuery(app: App<Element>) {
  app.use(VueQueryPlugin)
}
